"use client";

import { useEffect, useState } from "react";

/**
 * `SITE-CRS01`: true once the first element found among `ids` has scrolled up
 * past the top of the viewport, and false while it is on screen or still below
 * it. The course page's sticky enroll bars use it to appear only after the
 * card they repeat has gone. Off (false) while `enabled` is false.
 */
export function useScrolledPast(ids: readonly string[], enabled = true): boolean {
  const [past, setPast] = useState(false);
  const key = ids.join("|");
  useEffect(() => {
    if (!enabled) {
      setPast(false);
      return;
    }
    const el = key
      .split("|")
      .map((id) => document.getElementById(id))
      .find((node): node is HTMLElement => node !== null);
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        if (!e) return;
        setPast(!e.isIntersecting && e.boundingClientRect.bottom <= 0);
      },
      { root: null, threshold: 0 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [key, enabled]);
  return past;
}
